import { z } from "zod";

export const API_ERROR_CODES = [
  "BAD_REQUEST",
  "UNAUTHORIZED",
  "INVALID_CREDENTIALS",
  "INVALID_TOKEN",
  "FORBIDDEN",
  "EMAIL_NOT_VERIFIED",
  "NOT_FOUND",
  "CONFLICT",
  "EMAIL_TAKEN",
  "SLUG_TAKEN",
  "ALREADY_MEMBER",
  "PAYLOAD_TOO_LARGE",
  "VALIDATION_ERROR",
  "RATE_LIMITED",
  "INTERNAL_ERROR",
] as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[number];
export const apiErrorCodeSchema = z.enum(API_ERROR_CODES);

export const fieldErrorsSchema = z.record(z.string(), z.array(z.string()));
export type FieldErrors = z.infer<typeof fieldErrorsSchema>;

export const apiErrorBodySchema = z.object({
  code: apiErrorCodeSchema,
  message: z.string(),
  details: z
    .object({
      fieldErrors: fieldErrorsSchema.optional(),
    })
    .optional(),
});
export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>;

export interface ApiSuccess<T> {
  success: true;
  data: T;
}

export interface ApiFailure {
  success: false;
  error: ApiErrorBody;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

export const apiFailureSchema = z.object({
  success: z.literal(false),
  error: apiErrorBodySchema,
});

export function apiSuccessSchema<T extends z.ZodType>(data: T) {
  return z.object({ success: z.literal(true), data });
}

/** Empty success payload for endpoints that only acknowledge an action. */
export const emptyResponseSchema = z.object({});
export type EmptyResponse = z.infer<typeof emptyResponseSchema>;
